import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnitedInFaith from "./sections/UnitedInFaith";
import CaringForTheJourney from "./sections/CaringForTheJourney";
import LatestInsights from "./sections/LatestInsights";
import FeaturedSupportGuides from "./sections/FeaturedSupportGuides";
import StayTuned from "./sections/StayTuned";
import YourTrustedVoiceForPda from "./sections/YourTrustedVoiceForPda";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UnitedInFaith />
      <CaringForTheJourney />
      <LatestInsights />
      <FeaturedSupportGuides />
      <StayTuned />
      <YourTrustedVoiceForPda />
      <Footer />
    </div>;
}